export default "__VITE_ASSET__DHmyTpyC__"